// Aydınlık mod futbol topu ikonu - parlak, ışıltılı çerçeveli mavi tonlarda
export const LightModeIcon = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 100 100" className={className}>
    <defs>
      {/* Işıltılı glow efekti */}
      <filter id="lightGlow">
        <feGaussianBlur stdDeviation="2" result="blur"/>
        <feMerge>
          <feMergeNode in="blur"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
      {/* Ana top gradient - açık mavi tonları */}
      <linearGradient id="lightBallGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e0f0ff"/>
        <stop offset="50%" stopColor="#b8d8f8"/>
        <stop offset="100%" stopColor="#90c8f0"/>
      </linearGradient>
      {/* Pentagon gradient - mor/mavi tonları */}
      <linearGradient id="lightPentGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#7b8eb8"/>
        <stop offset="100%" stopColor="#5a70a0"/>
      </linearGradient>
    </defs>
    
    {/* Dış ışıltılı halka */}
    <circle cx="50" cy="50" r="46" fill="none" stroke="#60b0ff" strokeWidth="3" filter="url(#lightGlow)" opacity="0.7"/>
    <circle cx="50" cy="50" r="43" fill="none" stroke="#80d0ff" strokeWidth="1" opacity="0.5"/>
    
    {/* Ana top */}
    <circle cx="50" cy="50" r="38" fill="url(#lightBallGrad)" stroke="#a0c0e0" strokeWidth="1"/>
    
    {/* Futbol topu deseni - hexagonlar ve pentagonlar */}
    <g fill="none" stroke="#c8d8e8" strokeWidth="0.8">
      {/* Üst pentagon */}
      <polygon points="50,15 60,25 57,38 43,38 40,25" fill="url(#lightPentGrad)"/>
      
      {/* Orta hexagonlar */}
      <polygon points="40,25 30,30 28,42 38,50 50,45 50,30"/>
      <polygon points="60,25 70,30 72,42 62,50 50,45 50,30"/>
      
      {/* Orta sol pentagon */}
      <polygon points="28,42 20,55 25,68 38,68 43,55 38,50" fill="url(#lightPentGrad)"/>
      
      {/* Orta sağ pentagon */}
      <polygon points="72,42 80,55 75,68 62,68 57,55 62,50" fill="url(#lightPentGrad)"/>
      
      {/* Alt hexagonlar */}
      <polygon points="43,55 38,68 45,80 55,80 62,68 57,55"/>
      
      {/* Alt pentagon */}
      <polygon points="45,80 40,88 50,92 60,88 55,80" fill="url(#lightPentGrad)"/>
    </g>
    
    {/* Işık yansıması */}
    <ellipse cx="38" cy="28" rx="10" ry="6" fill="white" opacity="0.5"/>
    <ellipse cx="35" cy="25" rx="4" ry="2" fill="white" opacity="0.8"/>
  </svg>
);

// Karanlık mod futbol topu ikonu - koyu mor/siyah tonlarda
export const DarkModeIcon = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 100 100" className={className}>
    <defs>
      {/* Subtle alt ışık */}
      <filter id="darkGlow">
        <feGaussianBlur stdDeviation="3"/>
      </filter>
      {/* Ana top gradient - koyu mor tonları */}
      <linearGradient id="darkBallGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4a3a5a"/>
        <stop offset="50%" stopColor="#3a2a4a"/>
        <stop offset="100%" stopColor="#2a1a3a"/>
      </linearGradient>
      {/* Pentagon gradient - daha koyu */}
      <linearGradient id="darkPentGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#201830"/>
        <stop offset="100%" stopColor="#100820"/>
      </linearGradient>
      {/* Çizgi rengi */}
      <linearGradient id="darkLineGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3a5070"/>
        <stop offset="100%" stopColor="#2a4060"/>
      </linearGradient>
    </defs>
    
    {/* Ana top */}
    <circle cx="50" cy="50" r="38" fill="url(#darkBallGrad)" stroke="#2a3a50" strokeWidth="2"/>
    
    {/* Futbol topu deseni */}
    <g fill="none" stroke="url(#darkLineGrad)" strokeWidth="0.8">
      {/* Üst pentagon */}
      <polygon points="50,15 60,25 57,38 43,38 40,25" fill="url(#darkPentGrad)"/>
      
      {/* Orta hexagonlar */}
      <polygon points="40,25 30,30 28,42 38,50 50,45 50,30"/>
      <polygon points="60,25 70,30 72,42 62,50 50,45 50,30"/>
      
      {/* Orta sol pentagon */}
      <polygon points="28,42 20,55 25,68 38,68 43,55 38,50" fill="url(#darkPentGrad)"/>
      
      {/* Orta sağ pentagon */}
      <polygon points="72,42 80,55 75,68 62,68 57,55 62,50" fill="url(#darkPentGrad)"/>
      
      {/* Alt hexagonlar */}
      <polygon points="43,55 38,68 45,80 55,80 62,68 57,55"/>
      
      {/* Alt pentagon */}
      <polygon points="45,80 40,88 50,92 60,88 55,80" fill="url(#darkPentGrad)"/>
    </g>
    
    {/* Alt mavi ışık yansıması */}
    <ellipse cx="50" cy="92" rx="18" ry="4" fill="#4080c0" opacity="0.3" filter="url(#darkGlow)"/>
  </svg>
);

export default { LightModeIcon, DarkModeIcon };
